
















































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { messageFields } from '@/config/subscriptions';
import FormProvider from '@shared/components/forms/form-provider.vue';
import ContentWrapper from '@shared/layouts/wrappers/content-wrapper.vue';
import { Message } from '@communications/interfaces/message';

@Component({
  name: 'bpc-message-single',
  components: {
    'bpc-form-provider': FormProvider,
    'bpc-content-wrapper': ContentWrapper,
  },
})
export default class MessageSingle extends Vue {
  // PROPS
  @Prop(Object) readonly initialData: Partial<Message>;
  @Prop(Number) readonly modelId: number;
  @Prop({ type: Boolean, default: false }) readonly noFetchData: boolean;
  @Prop({ type: Boolean, default: false }) readonly showCloseButton: boolean;
  @Prop({ type: Boolean, default: false }) readonly disabled: boolean;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly value: Message;
  @Prop({
    type: String,
  })
  readonly closeButtonsPortalTarget: string;
  // DATA
  loading: boolean = false;

  // COMPUTED

  get formModel(): Message {
    return this.value;
  }
  set formModel(value) {
    this.$emit('input', value);
  }

  get fieldsConfig() {
    return messageFields;
  }

  get label() {
    return {
      labelAttributes: {
        for: 'test',
      },
      labelClass: {
        'mt-1 mb-0': true,
      },
    };
  }
  get col6() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-6 pl-2': true,
        },
      },
    };
  }
  get col12() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-12 pl-2': true,
        },
      },
    };
  }
  get col3() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-3 pl-2': true,
        },
      },
    };
  }
  get col4() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-4 pl-2': true,
        },
      },
    };
  }

  // LIFECYCLE
  // created(){}
  mounted() {
    if (this.modelId && this.noFetchData === false) {
      this.loadMessage();
    }
  }
  // updated(){}
  // destroyed(){}

  // METHODS
  loadMessage() {
    this.loading = true;
    const messageDetailRoute = `${this.$bpcApiRouteHelper.getEntityPath('messages')}/${
      this.modelId
    }`;

    this.$bpcApi.get(messageDetailRoute).subscribe(res => {
      this.formModel = res.data;
      this.loading = false;
    });
  }

  onClose() {
    this.$emit('close');
  }

  // WATCHERS
}
